export default __webpack_public_path__ + "static/media/singleCard.e4e8c36a.svg";